var render = function () {
  var _vm = this
  var _h = _vm.$createElement
  var _c = _vm._self._c || _h
  return _c("div", { staticClass: "btn-group btn-group-sm" }, [
    _c(
      "button",
      {
        staticClass: "btn btn-light dropdown-toggle",
        attrs: {
          disabled: _vm.numberOfCheckedModels === 0 || _vm.loading,
          type: "button",
          "data-bs-toggle": "dropdown",
          "aria-haspopup": "true",
          "aria-expanded": "true",
          id: "dropdownActions",
        },
      },
      [_vm._v("\n        " + _vm._s(_vm.$t("Action")) + "\n    ")]
    ),
    _vm._v(" "),
    _c(
      "div",
      {
        staticClass: "dropdown-menu",
        attrs: { "aria-labelledby": "dropdownActions" },
      },
      [
        _vm.publishable
          ? _c(
              "button",
              {
                staticClass: "dropdown-item",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("publish")
                  },
                },
              },
              [
                _vm._v("\n            " + _vm._s(_vm.$t("Publish")) + " "),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v("(" + _vm._s(_vm.locale) + ")"),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.publishable
          ? _c(
              "button",
              {
                staticClass: "dropdown-item",
                attrs: { type: "button" },
                on: {
                  click: function ($event) {
                    return _vm.$emit("unpublish")
                  },
                },
              },
              [
                _vm._v("\n            " + _vm._s(_vm.$t("Unpublish")) + " "),
                _c("span", { staticClass: "text-muted" }, [
                  _vm._v("(" + _vm._s(_vm.locale) + ")"),
                ]),
              ]
            )
          : _vm._e(),
        _vm._v(" "),
        _vm.publishable
          ? _c("div", { staticClass: "dropdown-divider" })
          : _vm._e(),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "dropdown-item",
            attrs: { type: "button" },
            on: {
              click: function ($event) {
                return _vm.$emit("destroy")
              },
            },
          },
          [_vm._v("\n            " + _vm._s(_vm.$t("Delete")) + "\n        ")]
        ),
        _vm._v(" "),
        _c("div", { staticClass: "divider", attrs: { role: "separator" } }),
        _vm._v(" "),
        _c(
          "button",
          {
            staticClass: "dropdown-item",
            attrs: { type: "button", disabled: "" },
          },
          [
            _c("small", [
              _vm._v(
                _vm._s(
                  _vm.$tc("# items selected", _vm.numberOfCheckedModels, {
                    count: _vm.numberOfCheckedModels,
                  })
                )
              ),
            ]),
          ]
        ),
      ]
    ),
  ])
}
var staticRenderFns = []
render._withStripped = true

export { render, staticRenderFns }